import ParsedData from "./common/ParsedData";


export default class PartnerCertificationsDTO implements ParsedData {

  public id?: number;
  public email?: string;
  public certification?: string;
  public region?: string;
  public account?: string;
  public name?: string;
  public completionTime?: string;
  public expirationTime?: string;

  constructor(name: string, certification: string) {
    this.name = name;
    this.certification = certification;
  }


}